import React from 'react';
import { Phone, Mail } from 'lucide-react';
import { businessInfo } from '../mock';

const Header = () => {
  return (
    <header className="bg-white border-b-2 border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_florida-remodel/artifacts/6wge7g1p_Brown%20Modern%20Simple%20Construction%20Logo%20-%205.PNG" 
              alt="SAGU Construction Logo" 
              className="h-16 w-auto object-contain"
            />
            <div>
              <h1 className="text-2xl font-bold text-gray-900">
                SAGU <span className="text-[#FFC222]">CONSTRUCTION</span>
              </h1>
              <p className="text-xs text-gray-600">Licensed & Insured • Orlando, FL</p>
            </div>
          </div>
          <div className="hidden md:flex items-center gap-6">
            <a href={`tel:${businessInfo.phone}`} className="flex items-center gap-2 text-gray-700 hover:text-[#FFC222] transition-colors">
              <Phone size={20} />
              <span className="font-semibold">{businessInfo.phone}</span>
            </a>
            <a href={`mailto:${businessInfo.email}`} className="flex items-center gap-2 text-gray-700 hover:text-[#FFC222] transition-colors">
              <Mail size={20} />
              <span className="font-semibold">{businessInfo.email}</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
